import { Item, ItemView, Rect, ImageItem } from "@albelli/image-list-view"
import * as React from "react"
import * as ReactDOM from "react-dom"

export type ContainerItem = Item | ImageItem

/**
 * ContainerItemView implements ItemView
 * it handles rendering of any given react component
 * it renders to created dom element and re-creates or destroys
 * on lazy loading requests (load/unload)
 * the component needs to be provided via callback function that accepts item
 * and returns any React Node
 *
 * it implements ItemView of oet-listView
 */
export class ContainerItemView implements ItemView {
  private rect!: Rect
  private element: HTMLElement | null = null

  constructor(private item: ContainerItem, private container: HTMLElement, private getComponent: (item: ContainerItem) => React.ReactElement<any>) {}

  load() {
    this.element = document.createElement("div")
    ReactDOM.render(this.getComponent(this.item), this.element)
    this.container.appendChild(this.element)
    this.setGeometry(this.rect)
  }
  setGeometry(geometry: Rect): void {
    this.rect = geometry
    if (this.element) {
      Object.assign(this.element.style, {
        position: "absolute",
        left: geometry.x + "px",
        top: geometry.y + "px",
        width: geometry.width + "px",
        height: geometry.height + "px"
      })
    }
  }
  unload() {
    if (this.element) {
      ReactDOM.unmountComponentAtNode(this.element)
      // ReactDOM.render(null, this.element)
      this.container.removeChild(this.element)
      this.element = null
    }
  }
  update(item: Item) {
    this.item = item
    if (this.element) {
      ReactDOM.render(this.getComponent(this.item), this.element)
    }
  }
  getRect(): Rect {
    return this.rect
  }
}
